module.exports = __webpack_public_path__ + "img/1532092810.862e8a1f.jpg";